import React, { useState } from 'react';
import { LeftArrow, MailIcon } from '../../icons';
import Container from '../../components/elements/container';
import { notificationsIcons } from '../../config/constants';

const Notifications = ({ isLoading, notificationData }) => {
  const [messageDetails, setSelectedMessage] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const windowWidth = window.screen.width;

  if (isLoading) {
    return <Container>Loading..</Container>;
  }

  // if (showDetails && windowWidth <= 991) {
  //   return (
  //     <div className="lg:hidden container-sm bg-transparent lg:max-h-[95vh] h-full overflow-y-auto flex flex-col px-5 gap-5">
  //       <div className="flex gap-3 border-b border-b-fadedgrey py-2">
  //         <button
  //           type="button"
  //           className=""
  //           onClick={() => setShowDetails(false)}
  //         >
  //           <LeftArrow />
  //         </button>
  //         <h2>Messages</h2>
  //       </div>
  //       <div className="flex border border-fadedgrey p-5 rounded-md">
  //         <div className="flex flex-col gap-2">
  //           <h6>{messageDetails.title}</h6>
  //           <p className="text-body text-granite ">{messageDetails.message}</p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <Container className="flex flex-col gap-6">
      <h2>Ειδοποιήσεις</h2>
      <div className="grid max-lg:grid-rows-3 max-lg:grid-cols-1 grid-rows-1 lg:grid-cols-3 max-lg:gap-0 gap-4 flex-1 min-h-0">
        <ul className="max-lg:row-span-2 flex flex-col gap-3 overflow-y-auto scrollbar max-lg:border-b min-h-0 lg:pe-4 lg:[&::-webkit-scrollbar]:w-1 lg:[&::-webkit-scrollbar-track]:bg-white lg:[&::-webkit-scrollbar-thumb]:bg-black lg:[&::-webkit-scrollbar-thumb]:rounded-full lg:[&::-webkit-scrollbar-thumb:hover]:bg-black">
          {notificationData.notifications.map((messageData) => {
            const { id, title, message, created_at } = messageData;

            if (messageDetails && id === messageDetails.id) {
              return (
                <li
                  key={id}
                  className="flex bg-white border-2 border-[#1A2540] rounded-xl p-4 gap-3"
                  role="button"
                  onClick={() => setSelectedMessage(messageData)}
                >
                  <div className="flex gap-2 w-full min-w-0">
                    <div className="flex flex-wrap gap-2 items-center flex-1 min-w-0">
                      <div className='flex flex-row gap-2 min-w-0 w-full'>
                        {notificationsIcons(messageData)?.headIcon}
                        <h6 className="text-black">
                          <span>
                            {title}{" "}
                          </span>
                          <span>
                            {notificationsIcons(messageData)?.leadIcon}
                          </span>
                        </h6>
                      </div>
                      <p title={message} className="text-body text-black overflow-hidden truncate">
                        {message}
                      </p>
                      <div className='flex items-center shrink-0 ml-auto'>                
                        <p className='text-black text-disclaimer'>
                          {created_at &&
                            new Date(created_at).toLocaleDateString("el-GR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              timeZone: "UTC",
                            })}
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              );
            }

            return (
              <li
                  key={id}
                  className="flex bg-white border-2 border-transparent rounded-xl p-4 gap-3"
                  role="button"
                  onClick={() => setSelectedMessage(messageData)}
                >
                  <div className="flex flex-wrap gap-2 items-center w-full min-w-0">
                      <div className='flex flex-row gap-2 w-full'>
                        {notificationsIcons(messageData)?.headIcon}
                        <h6 className="text-black">
                          <span>
                            {title}{" "}
                          </span>
                          <span>
                            {notificationsIcons(messageData)?.leadIcon}
                          </span>
                        </h6>
                      </div>
                      <p title={message} className="text-body text-black overflow-hidden truncate">
                        {message}
                      </p>
                      <div className='flex items-center shrink-0 ml-auto'>                
                        <p className='text-black text-disclaimer'>
                          {created_at &&
                            new Date(created_at).toLocaleDateString("el-GR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              timeZone: "UTC",
                            })}
                        </p>
                      </div>
                  </div>
                  
                </li>
            );
          })}
        </ul>
        {messageDetails ? (
          <div className="max-lg:row-span-1 max-lg:mt-5 lg:col-span-2 flex p-6 rounded-xl bg-white h-fit">
            <div className="flex">
              <div className="flex flex-col gap-4">
                <h4>
                  <span>
                    {messageDetails?.title}{" "}
                  </span>
                  <span>
                    {notificationsIcons(messageDetails)?.leadIcon}
                  </span>
                </h4>
                <p className="text-body text-granite ">
                  {messageDetails.message}
                </p>
                <p className='text-black text-disclaimer'>
                  {messageDetails?.['created_at'] &&
                    new Date(messageDetails?.['created_at']).toLocaleDateString("el-GR", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      timeZone: "UTC",
                    })}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="max-lg:hidden col-span-2 flex p-6 border border-fadedgrey rounded-lg bg-white h-[300px] items-center justify-center">
            <div className="text-body text-granite">
            Επίλεξε μια ειδοποίηση για να διαβάσεις όλο το περιεχόμενο.
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default Notifications;
